<template>
  <div class="group">
    <div class="group-edit-tap">
      <div class="tap main" :class="{ on: target === 'heatmap' }" @click="onTapSelect('heatmap')">{{ $t('heatmap.edit.target.heatmap') }}</div>
      <div class="tap" v-if="!isExactMatchType" :class="{ on: target === 'group' }" @click="onTapSelect('group')">{{ $t('heatmap.edit.target.group') }}</div>
    </div>
    <ba-heatmap-edit-mode v-if="target === 'heatmap' && isLoadedDomain" :domains="domains"/>
    <ba-group-edit-mode v-if="target === 'group'"/>
  </div>
</template>

<script>
import store from '@/store'
import BaGroupEditMode from '@/components/group/EditMode'
import BaHeatmapEditMode from '@/components/group/HeatmapEditMode'
import { CommonStorage } from '@/libs/auth-helper'
import { getDomains } from '@/api/domain'
import { compare09aAzZ } from '@/libs/utils'
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'Group',
  components: {
    BaGroupEditMode,
    BaHeatmapEditMode
  },
  data () {
    return {
      target: 'heatmap',
      isLoadedDomain: false,
      domains: null
    }
  },
  computed: {
    ...mapState([
      'journeyOptions'
    ]),
    sid () {
      return this.$route.query.sid
    },
    isExactMatchType () {
      return this.journeyOptions.matchType === 'exact'
    }
  },
  beforeRouteEnter (to, from, next) {
    const sid = store.state.journeyOptions.sid
    if (sid && from && from.name) {
      CommonStorage.setItem(`reportView-${sid}`, from.name)
    }
    next()
  },
  created () {
    this.loadDomains()
    const reportViewStorageKey = `reportView-${this.sid}`
    const storedReportView = CommonStorage.getItem(reportViewStorageKey) || 'ranking'
    const reportView = storedReportView === 'sitemap' ? 'ranking' : storedReportView
    if (storedReportView === 'sitemap') {
      CommonStorage.setItem(reportViewStorageKey, reportView)
    }
    if (reportView === 'ranking') {
      this.target = 'heatmap'
    } else {
      this.target = 'group'
    }
  },
  methods: {
    ...mapMutations([
      'setJourneyOptions',
      'setDomain'
    ]),
    onTapSelect (item) {
      this.target = item
    },
    loadDomains () {
      if (!this.journeyOptions || this.journeyOptions.domain) {
        getDomains(this.sid, false).then(result => {
          result.sort(compare09aAzZ)
          result.forEach(item => {
            item.existSubdomains = false
            if (item.subDomains.length > 0) {
              item.existSubdomains = true
            }
            item.openSubDomains = false
          })
          this.domains = result

          for (const domain of result) {
            if ([domain.orgSid, domain.sid].includes(this.sid)) {
              this.setDomain(domain)
              this.setJourneyOptions({
                ...this.journeyOptions,
                domain: domain.domain,
                sid: this.sid,
                timezone: domain.timezone,
                timezoneName: domain.timezoneName
              })
              break
            }
          }
          this.domains = result
          this.isLoadedDomain = true
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.group {
  .group-edit-tap {
    display: flex;
    height: 44px;
    margin: 0 30px;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    position: relative;
    .tap {
      position: relative;
      padding: 16px 5px 7px 5px;
      color: #999;
      cursor: pointer;
      &.on {
        color: #2F2F2F;
        &::after {
          content: "";
          position: absolute;
          display: block;
          width: 100%;
          height: 3px;
          background-color: #EC0047;
          bottom: 0;
          left: 0;
          z-index: 5;
        }
      }
      &.main {
        margin-right: 40px;
      }
    }
    &::after {
      content: "";
      position: absolute;
      display: block;
      width: 100%;
      height: 1px;
      background-color: #D7D7D7;
      bottom: 0;
    }
  }
}
</style>
